<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col md:w-1/2 w-full">
        <h2>{{ $t('table.Mesas') }}</h2>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <div class="text-right">
          <vs-button @click="popupNewTable = true" color="primary" type="border">{{ $t('table.NuevaMesa') }}</vs-button>
          <vs-popup :title="$t('table.NuevaMesa')" class="popup-w-900" :active.sync="popupNewTable">
            <new-table></new-table>
          </vs-popup>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <table-data-grid :data="itemsDataGrid" :dataColumns="dataColumns" link="table">
          <template v-slot:actions="slotProps">
            <div class="dropdown-button-container">
              <vs-button class="btnx" type="filled" color="primary" @click="editTable(slotProps.item.id)">
                {{ $t('Editar') }}
              </vs-button>
              <vs-dropdown>
                <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
                <vs-dropdown-menu>
                  <ul style="min-width: 12rem">
                    <li>
                      <generate-qr
                        :id="slotProps.item.id"
                        class="cursor-pointer py-3 px-4 block hover:bg-primary text-primary hover:text-white w-full"
                        type="table"
                      >
                        <template slot="text" >
                            <font-awesome-icon
                              :icon="['fas', 'qrcode']"
                              class="w-4 h-4"
                            />
                          <span class="ml-2 mt-5">
                            {{ $t('GenerarQR') }}
                          </span>
                        </template>
                      </generate-qr>
                    </li>
                    <vs-divider class="m-1" />
                    <li>
                      <span
                        @click="deleteModalTable(slotProps.item.id, slotProps.item.name)"
                        class="cursor-pointer py-3 px-4 block hover:bg-danger text-danger hover:text-white w-full"
                      >
                        <feather-icon icon="TrashIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">{{ $t('Eliminar') }}</span>
                      </span>
                    </li>
                  </ul>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </template>
          <template v-slot:active="slotProps">
            <feather-icon
              icon="CheckCircleIcon"
              svgClasses="w-5 h-5 text-success hover:text-black stroke-current"
              @click="deactiveModalTable(slotProps.item.id, slotProps.item.name)"
            />
          </template>
          <template v-slot:deactive="slotProps">
            <feather-icon
              icon="XCircleIcon"
              svgClasses="w-5 h-5 text-danger hover:text-black stroke-current"
              @click="activeModalTable(slotProps.item.id, slotProps.item.name)"
            />
          </template>
          <template v-slot:name="slotProps">
            {{ slotProps.item.name }}
          </template>
        </table-data-grid>
        <vs-popup title="Edición mesa" class="popup-w-900" v-if="openModal" :active.sync="popupEditTable">
          <edit-table :table="table" v-if="openModal" />
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import TableDataGrid from '../TableDataGrid';
import NewTable from './NewTable';
import EditTable from './EditTable';
import GenerateQr from '../GenerateQr';
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  props: {
    restaurant: {
      type: Object,
      required: true,
    },
  },
  components: {
    TableDataGrid,
    NewTable,
    EditTable,
    GenerateQr
  },
  data () {
    return {
      dialog: false,
      dataColumns: [
        { dataField: 'id', caption: 'ID', visible: false },
        { dataField: 'name', caption: this.$t('Nombre'), dataType: 'text', visible: true, width: 300 },
        /* { caption: this.$t('Código QR'), dataType: 'image', visible: true, width: 175 },
        { dataField: 'nfc', caption: this.$t('NFC'), dataType: 'text', visible: true, width: 100 },*/
        { dataField: 'terrace', caption: this.$t('Terraza'), dataType: 'text', visible: true, width: 150 },
        { dataField: 'active', caption: this.$t('Activo'), dataType: 'slot', visible: true },
      ],
    };
  },
  created () {
    this.refreshTables({ restaurant_id: this.restaurant.id, language: this.language });
  },
  computed: {
    ...mapGetters({
      itemsTables: 'getTables',
      table: 'getTable',
      language: 'getCurrentLanguage',
    }),
    popupEditTable: {
      get () {
        return this.$store.getters.getpopupEditTable;
      },
      set (val) {
        this.$store.commit('setpopupEditTable', val);
      },
    },
    popupNewTable: {
      get () {
        return this.$store.getters.getpopupNewTable;
      },
      set (val) {
        this.$store.commit('setpopupNewTable', val);
      },
    },
    openModal () {
      if (this.popupEditTable === true && Object.keys(this.table).length > 0) {
        return true;
      }
      return false;
    },
    itemsDataGrid () {
      const items = this.itemsTables;
      const results = [];
      const placeholder = process.env.VUE_APP_IMAGE_PLACEHOLDER;
      if (Object.keys(items).length) {
        items.forEach(function (item, index) {
          results[index] = {
            id: items[index].id,
            name: items[index].name,
            /*qrCode: `<img src="${placeholder}" style="width: 175px;" class="product-img" >`,
            nfc: items[index].nfc,*/
            terrace: '',
            active: 'deactive',
          };
          if (items[index].terrace === 1) {
            results[index].terrace = 'Sí';
          } else {
            results[index].terrace = 'No';
          }
          if (items[index].active === 1) {
            results[index].active = 'active';
          }
        }, items);
      }

      return results;
    },
  },
  methods: {
    ...mapActions({
      refreshTables: 'refreshTables',
      activeTable: 'activeTable',
      deactiveTable: 'deactiveTable',
      deleteTable: 'deleteTable',
      getTable: 'getTable',
    }),
    ...mapMutations({
      setTable: 'setItemTable',
      loading: 'loading',
    }),
    editTable (id) {
      this.setTable({});
      this.getTable({ id, language: this.language });
      this.popupEditTable = true;
    },
    deleteModalTable (id, name) {
      const aux = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('table.EliminarMesa'),
        text: this.$t('table.EliminarConfirm', { nombre: name }),
        acceptText: this.$t('Aceptar'),
        cancelText: this.$t('Cancelar'),
        accept () {
          aux.deleteTable(id);
        },
      });
    },
    activeModalTable (id, name) {
      const aux = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: this.$t('table.ActivarMesa'),
        text: this.$t('table.ActivarConfirm', { nombre: name }),
        acceptText: this.$t('Aceptar'),
        cancelText: this.$t('Cancelar'),
        accept () {
          aux.activeTable(id);
        },
      });
    },
    deactiveModalTable (id, name) {
      const aux = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('table.DesactivarMesa'),
        text: this.$t('table.DesactivarConfirm', { nombre: name }),
        acceptText: this.$t('Aceptar'),
        cancelText: this.$t('Cancelar'),
        accept () {
          aux.deactiveTable(id);
        },
      });
    },
  },
};
</script>

<style></style>
